<rds-badge [size]="size" [label]="badge.label" [type]="badge.type" [color]="badge.color"></rds-badge>